import React from "react";
import Button from "@mui/material/Button";
import { SvgIcon } from "../../SvgIcon";
import { Tooltip } from "@mui/material";
import { styled ,useTheme} from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import ScreenShareOutlinedIcon from '@mui/icons-material/ScreenShareOutlined';
import StopScreenShareOutlinedIcon from '@mui/icons-material/StopScreenShareOutlined';
const CustomizedBtn = styled(Button)(({ theme }) => ({
  "&.footer-icon-button": {
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: 8,
      minWidth: "unset",
      width: "100%",
    },
    "& > svg": {
      width: 36,
    },
  },
}));

function ShareScreenButton(props) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Tooltip
      title={props?.isScreenShared ? t("You are presenting") : t("Present now")}
      placement="top"
    >
      <CustomizedBtn
        className={props?.footer ? "footer-icon-button" : ""}
        id = "share-screen-button"
        onClick={() => {
          if (props?.isScreenShared) {
            props?.handleStopScreenShare();
          } else {
            props?.handleStartScreenShare();
            // send other that you are sharing screen.
          }
        }}
        variant="contained"
        color={props?.isScreenShared ? "primary" : "primary"}
      >
         {props.isScreenShared ? 
          <StopScreenShareOutlinedIcon sx={{fontSize:'24px',color:theme.palette.iconColor.default}} />
        :
        <ScreenShareOutlinedIcon sx={{fontSize:'24px',color:theme.palette.iconColor.default}} />

        }
        {/* <SvgIcon
          color={props?.isScreenShared ? theme.palette?.iconColor?.default : theme.palette?.iconColor?.default}
          size={40}
          name={"share-screen-off"}
        /> */}
      </CustomizedBtn>
    </Tooltip>
  );
}

export default ShareScreenButton;
